var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "graphic-info-container" },
    [
      _c(
        "el-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [_c("TitleItem", { attrs: { title: "图文信息" } })]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            {
              ref: "graphicInfoForm",
              attrs: { model: _vm.graphicInfoModel, "label-width": "125px" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "卖点描述" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "30",
                              placeholder: "请输入套餐卖点描述(至多30字)"
                            },
                            model: {
                              value: _vm.graphicInfoModel.description,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.graphicInfoModel,
                                  "description",
                                  $$v
                                )
                              },
                              expression: "graphicInfoModel.description"
                            }
                          }),
                          _c("p", { staticClass: "desc-tips" }, [
                            _vm._v(
                              "用于描述商品售卖亮点、商品优势，商品详情页面标题下方展示"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "套餐图片", required: "" } },
                [
                  _c("ImageUpload", {
                    ref: "goodsPicRef",
                    attrs: { sizeLimit: 1 }
                  }),
                  _c("p", { staticClass: "desc-tips" }, [
                    _vm._v(
                      "\n          仅支持jpg、png、jpeg文件格式,文件大小建议1M以内,建议尺寸:460像素x460素,至少上传1张图,至多上传10张图,商品图片可展在商品详情页面或视频缩略图\n        "
                    )
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "套餐视频" } },
                [
                  _c("VideoUpload", { ref: "goodsVideoRef" }),
                  _c("p", { staticClass: "desc-tips" }, [
                    _vm._v(
                      "仅支持mp4、webm、ogv格式视频文件,建议视频时间在30s以内,大小不超过50m,至多上传1个视频商品视频可展示在商品详情或商品列表中"
                    )
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "套餐详情", required: "" } },
                [
                  _c("Tinymce", {
                    ref: "tinymce",
                    attrs: { id: "id", contentInit: _vm.contentInit }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "其他说明" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "30", "show-word-limit": "" },
                            model: {
                              value: _vm.graphicInfoModel.using,
                              callback: function($$v) {
                                _vm.$set(_vm.graphicInfoModel, "using", $$v)
                              },
                              expression: "graphicInfoModel.using"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }